(() => {
  if (window.FultonsSelectors) return;
  const instances = new Map();
  let sequence = 0, active = null, queued = false;
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };
  function eligible(select) {
    if (select.multiple || select.size > 1 || select.hidden || select.getAttribute('aria-hidden') === 'true' || select.tabIndex === -1) return false;
    if (select.closest('[data-living-filters],.fc-source-form,shopify-payment-terms,[data-fultons-native-select],[inert]')) return false;
    const style = getComputedStyle(select), box = select.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && box.width > 1 && box.height > 1;
  }
  function enhance(select) {
    const id = 'fultons-select-' + (++sequence);
    const wrapper = make('span', 'fs-picker');
    const button = make('button', 'fs-picker__toggle');
    const value = make('span', 'fs-picker__value');
    const chevron = make('span', 'fs-picker__chevron');
    const panel = make('span', 'fs-picker__panel');
    const list = make('span', 'fs-picker__list');
    const labels = Array.from(select.labels || []);
    const readName = () => {
      const labelText = Array.from(new Set([...labels, ...Array.from(select.labels || [])])).filter(label => label.isConnected && (label.contains(select) || label.htmlFor === select.id)).map(label => { const copy = label.cloneNode(true); copy.querySelectorAll('select,button,input,textarea,.fs-picker').forEach(node => node.remove()); return copy.textContent.trim(); }).filter(Boolean).join(' ');
      const originalLabel = select.getAttribute('aria-labelledby')?.split(/\s+/).map(key => document.getElementById(key)?.textContent.trim()).filter(Boolean).join(' ');
      return labelText || originalLabel || select.getAttribute('aria-label') || select.title || select.name || select.id;
    };
    const name = make('span', 'fs-picker__label', readName());
    name.id = id + '-label';
    button.type = 'button'; button.id = id + '-toggle'; value.id = id + '-value'; list.id = id + '-list';
    button.setAttribute('role', 'combobox'); button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-controls', list.id);
    button.setAttribute('aria-labelledby', name.id + ' ' + value.id);
    for (const name of ['aria-describedby', 'aria-required']) if (select.hasAttribute(name)) button.setAttribute(name, select.getAttribute(name));
    chevron.setAttribute('aria-hidden', 'true');
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-labelledby', name.id);
    panel.hidden = true; button.append(value, chevron); panel.append(list);
    select.before(wrapper); wrapper.append(name, button, panel, select);
    select.classList.add('fs-picker__native'); select.tabIndex = -1; select.setAttribute('aria-hidden', 'true');
    let open = false, index = 0, signature = '', buffer = '', typedAt = 0, invalid = false;
    const enabled = () => Array.from(select.options).map((option, i) => ({option, i})).filter(({option}) => !option.disabled && !option.hidden && !option.parentElement.disabled);
    const close = () => {
      open = false; panel.hidden = true; button.setAttribute('aria-expanded', 'false'); button.removeAttribute('aria-activedescendant'); buffer = '';
      if (active === api) active = null;
    };
    const highlight = next => {
      const choices = enabled(); if (!choices.length) return;
      index = choices.some(item => item.i === next) ? next : choices[0].i;
      for (const row of list.querySelectorAll('[role=option]')) row.dataset.active = String(Number(row.dataset.index) === index);
      if (open) {
        button.setAttribute('aria-activedescendant', id + '-option-' + index);
        document.getElementById(id + '-option-' + index)?.scrollIntoView?.({block: 'nearest'});
      }
    };
    const refresh = () => {
      const options = Array.from(select.options);
      const nextName = readName();
      const next = JSON.stringify([nextName, select.getAttribute('aria-describedby'), select.value, select.selectedIndex, select.matches(':disabled'), select.required, select.hidden, select.style.display, options.map(option => [option.value, option.textContent, option.disabled, option.hidden, option.parentElement.disabled, option.dataset.fultonsSelectImage])]);
      if (signature === next) return;
      signature = next;
      name.textContent = nextName;
      if (select.hasAttribute('aria-describedby')) button.setAttribute('aria-describedby', select.getAttribute('aria-describedby')); else button.removeAttribute('aria-describedby');
      value.textContent = select.selectedOptions[0]?.textContent || '';
      button.disabled = select.matches(':disabled') || !enabled().length;
      button.setAttribute('aria-required', String(select.required));
      wrapper.hidden = select.hidden || select.style.display === 'none';
      if (invalid) { invalid = !select.validity.valid; button.setAttribute('aria-invalid', String(invalid)); }
      list.replaceChildren();
      let group = null;
      options.forEach((option, i) => {
        if (option.hidden) return;
        const parent = option.parentElement;
        if (parent.tagName === 'OPTGROUP' && parent !== group) { group = parent; const title = make('span', 'fs-picker__group', parent.label); title.setAttribute('role', 'presentation'); list.append(title); }
        const row = make('span', 'fs-picker__option'); row.id = id + '-option-' + i; row.dataset.index = String(i);
        row.setAttribute('role', 'option'); row.setAttribute('aria-selected', String(i === select.selectedIndex));
        row.setAttribute('aria-disabled', String(option.disabled || Boolean(parent.disabled)));
        if (option.dataset.fultonsSelectImage) {
          const image = make('img', 'fs-picker__thumbnail'); image.src = option.dataset.fultonsSelectImage; image.alt = ''; image.width = 28; image.height = 28; image.loading = 'lazy'; row.append(image); row.classList.add('fs-picker__option--image');
        }
        const copy = make('span', 'fs-picker__copy', option.textContent), check = make('span', 'fs-picker__check', '✓'); check.setAttribute('aria-hidden', 'true'); row.append(copy, check);
        row.addEventListener('pointerdown', event => { if (event.pointerType === 'mouse') event.preventDefault(); });
        row.addEventListener('pointermove', event => { if (event.pointerType !== 'touch' && !option.disabled && !parent.disabled) highlight(i); });
        row.addEventListener('click', () => choose(i)); list.append(row);
      });
      if (button.disabled || wrapper.hidden) close();
      highlight(select.selectedIndex);
    };
    const show = () => {
      refresh(); if (button.disabled) return;
      if (active && active !== api) active.close();
      document.dispatchEvent(new CustomEvent('fultons:selector-open', {detail: {buttonId: button.id}}));
      open = true; active = api; panel.hidden = false; button.setAttribute('aria-expanded', 'true'); highlight(select.selectedIndex);
    };
    const choose = next => {
      const option = select.options[next];
      if (!option || option.disabled || option.hidden || option.parentElement.disabled) return;
      const changed = select.selectedIndex !== next;
      select.selectedIndex = next; close(); refresh(); button.focus({preventScroll: true});
      if (changed) { select.dispatchEvent(new Event('input', {bubbles: true})); select.dispatchEvent(new Event('change', {bubbles: true})); }
      refresh();
    };
    const api = {select, wrapper, button, refresh, close}; instances.set(select, api);
    for (const property of ['value', 'selectedIndex']) {
      const descriptor = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, property);
      if (!Object.prototype.hasOwnProperty.call(select, property) && descriptor?.get && descriptor?.set) Object.defineProperty(select, property, {configurable: true, get() { return descriptor.get.call(this); }, set(next) { descriptor.set.call(this, next); refresh(); }});
    }
    wrapper.addEventListener('click', event => event.preventDefault());
    button.addEventListener('click', () => open ? close() : show());
    button.addEventListener('keydown', event => {
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault(); const wasOpen = open; if (!open) show();
        const choices = enabled().map(item => item.i), position = choices.indexOf(index);
        let next = index;
        if (event.key === 'Home') next = choices[0]; else if (event.key === 'End') next = choices[choices.length - 1];
        else if (wasOpen) next = choices[Math.max(0, Math.min(choices.length - 1, position + (event.key === 'ArrowDown' ? 1 : -1)))];
        highlight(next);
      } else if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); if (open) choose(index); else show(); }
      else if (event.key === 'Escape' && open) { event.preventDefault(); event.stopPropagation(); close(); }
      else if (event.key === 'Tab') close();
      else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        const now = Date.now(); buffer = now - typedAt > 700 ? event.key.toLowerCase() : buffer + event.key.toLowerCase(); typedAt = now;
        if (!open) show(); const match = enabled().find(item => item.option.textContent.trim().toLowerCase().startsWith(buffer));
        if (match) { event.preventDefault(); highlight(match.i); }
      }
    });
    select.addEventListener('change', refresh); select.addEventListener('input', refresh);
    select.addEventListener('invalid', event => { event.preventDefault(); invalid = true; button.setAttribute('aria-invalid', 'true'); button.focus({preventScroll: false}); show(); });
    labels.forEach(label => label.addEventListener('click', event => { if (event.target === label) { event.preventDefault(); button.focus(); } }));
    refresh();
  }
  function scan() {
    queued = false;
    for (const [select, instance] of instances) { if (!select.isConnected) { instance.close(); instances.delete(select); } else instance.refresh(); }
    document.querySelectorAll('select').forEach(select => { if (!instances.has(select) && eligible(select)) enhance(select); });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(scan); } }
  function start() {
    scan();
    new MutationObserver(records => {
      if (records.some(record => !(record.target.nodeType === 1 ? record.target : record.target.parentElement)?.closest('.fs-picker__panel,.fs-picker__toggle,.fs-picker__label'))) schedule();
    }).observe(document.body, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'disabled', 'selected', 'required', 'value', 'label', 'open', 'style', 'class', 'aria-label', 'aria-labelledby', 'aria-describedby', 'data-fultons-select-image']});
    document.addEventListener('pointerdown', event => { if (active && !active.wrapper.contains(event.target)) active.close(); });
    document.addEventListener('focusin', event => { if (active && !active.wrapper.contains(event.target)) active.close(); });
    document.addEventListener('reset', () => setTimeout(scan, 0), true);
    window.addEventListener('pageshow', scan);
    document.addEventListener('shopify:section:load', scan);
  }
  window.FultonsSelectors = {refresh: scan};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
})();
